import { render, staticRenderFns } from "./tzserver.vue?vue&type=template&id=1f1224e9&scoped=true&"
import script from "./tzserver.vue?vue&type=script&lang=js&"
export * from "./tzserver.vue?vue&type=script&lang=js&"
import style0 from "./tzserver.vue?vue&type=style&index=0&id=1f1224e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1224e9",
  null
  
)

export default component.exports